import React from "react";
const Nav = () => {
  return (
    <>
      <div className=" border-l-black border-2 w-full">
        <div className="w-[50%]">
          <div className="w-60 flex items-center justify-around mx-auto">
            <img
              className="h-20 w-20 object-fill"
              src="https://i.pinimg.com/originals/4d/76/01/4d76019a06cd392cc8f854f225567383.png"
              alt="suvayapurple logo"
            />
            <h2>Online food and fruit Dictonary</h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default Nav;
